<template>
  <div class="softphone-wraper">
    <div v-if="!error.show" class="soft-phone">
        <div class="container">
          <div class="content" v-if="connected">
            <the-keypad class="center" v-if="active === 'keypad'" :onlyNumbers="true" @call="call" @send-dtmf="sendDtmf"></the-keypad>
            <the-incall class="center" v-else-if="active === 'incall'" :currentCall="currentCall" :display-name="displayName" :callerid="callerid" :call-date="callDate" @transfer-call="active = 'transfer'" @hangup="simpleHangup" @unmute="unmute" @mute="mute" @unhold="unhold" @hold="hold" @send-dtmf="sendDtmf"></the-incall>
            <the-calling class="center" v-else-if="active === 'calling'" :display-name="displayName" ref="calling" @hangup="simpleHangup"></the-calling>
            <the-incoming-call v-else-if="active === 'incoming'" :janus="janus"  :callerid="callerid" :display-name="displayName" :jsep="jsep" :stop-audio="!active!='incoming'"></the-incoming-call>
            <the-transfer v-else-if="active === 'transfer'" :currentCall="currentCall" @back="active = 'incall'" @send-dtmf="sendDtmf" @assisted-transfer="assistedTransfer" @bind-transfer="bindTransfer" @go-back-to-call="goBackToCall" @hangup="simpleHangup" @mute="mute" @unmute="unmute" @hold="hold" @unhold="unhold">
              <template v-slot:transfer-template>
                  <slot name="transfer-template"></slot>
              </template>
            </the-transfer>
          </div>
          <div v-else class="content">
            <div>
              <p class="text-center">Conectandose, espere por favor</p>
              <div v-loading="!connected" style="background:transparent"></div>
            </div>
          </div>
        </div>
    </div>
    <video ref="sipAudio" autoplay playsinline loop style="display:none"></video>
    <audio ref="audio" loop>
      <source :src="src" type="audio/ogg" />
    </audio>
    <video id="widget-audio" autoplay playsinline style="display: none" loop></video>
    <widget-error v-if="error.show" :error="error.type"></widget-error>    
  </div>
</template>

<script>
const AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext;

import TheKeypad from '@/components/softphone-widget/TheKeyPad.vue'
import createNotification from "@/plugins/notification"
import { mapActions, mapGetters } from 'vuex'
import TheIncall from '@/components/softphone-widget/TheInCall.vue'
import TheCalling from '@/components/softphone-widget/TheCalling.vue'
import TheIncomingCall from '@/components/softphone-widget/TheIncomingCall.vue'
import janus from '@/plugins/janus-proxy'
import TheTransfer from '@/components/softphone-widget/TheTransfer.vue'
import Tone from "@/plugins/tone";
import WidgetError from '@/components/softphone-widget/WidgetError.vue'

export default {
  props: {
    extension: {
      type: Object,
      required: true
    }
  },
  components : {
    TheIncall,
    TheKeypad,
    TheCalling,
    TheIncomingCall,
    TheTransfer,
    WidgetError
},
  data() {
    return {
      janus : null,
      jsep : null,
      callerid : null,
      loadingJanus : false,
      previusUserStatus : '',
      displayName : null,
      callDate : null,
      src: process.env.VUE_APP_DEFAULT_RINGTONE,
      callKey: null,
      connected: false,
      active: 'keypad',
      dtmf: new Tone(new AudioContext(), 350, 440),
      error: {
        show: false,
        type: null
      },
      currentCall: {
        mute: false,
        hold: false
      }
    }
  },
  computed : {
    ...mapGetters({
      inputDevice : 'getInputAudioDevice',
      voicemail : 'getVoicemail', 
      isMainWindow : 'getIsMainWindow',
      janusConf: 'getJanusConfig',
      actions:'getActions',
      volume: 'getOutputAudioVolume',
      outputDevice: 'getOutputAudioDevice',
    })
  },
  methods: {
    ...mapActions(['setVoicemail', "setIsListeningVoicemail"]),
    async initJanus() {
      const methods = {
        incomingcall : this.incomingcall,
        calling : this.calling,
        accepted : this.accepted,
        hangup : this.hangup,
        notify : this.notify,
        registered : this.registered,
      }
      if (!this.extension.janus_server || this.loadingJanus) {
        return
      }
      this.$emit('init-janus')
      const _janus = await janus.init(this.extension.janus_server.servers, this.extension.janus_server.secret, this.extension, this.extension.stunServer ); 
      this.loadingJanus = true;

      _janus.onSipMessage((message, jsep) => {
        if (message.result) {
          const event = message.result.event
          
          if (event in methods) {
            methods[event](message.result, jsep)
          }

          if (event === "progress") {
            this.$refs.calling.stop()
          }

          if(event === "registration_failed") {
            this.registrationFailed()
          }

        }
      })
    
      if (_janus) {
        _janus.onCallingError((error) => {
          this.$alert(error);
        });

        _janus.onErrorAttachSip((error) => {
          this.$alert(error);
        });

        _janus.attachAudio(this.$refs.sipAudio)
        _janus.attachAudio(document.querySelector("#widget-audio"));
        _janus.onDestroyedSession(() => {
          this.onJanusDestroy();
        });

        try {
          await _janus.startConnection()
          this.connected = true
          _janus.startPing((connected) => {
            this.connected = connected
            if (!this.connected) {
              this.hangup({ code: 400})
              _janus.reconnect()
            }
          })
        } catch (err) {
          if (err === "Error connecting to any of the provided Janus servers: Is the server down?") {
            setTimeout(() => {
              this.onJanusDestroy();
            }, 10000)
            return;
          }
        }
      }

      setTimeout(() => {
        this.janus = _janus
      }, 5000)
    },
    async incomingcall(result, jsep) {
      this.jsep = jsep;
      this.active = 'incoming';
      this.displayName = result.displayname;
      this.callKey = result.callKey;
      this.callerid = result.username.replace('sip:', '').split('@').shift();
      createNotification(this.$t("call.incoming-call-notification", { callerid : this.displayName }))
      this.play();
      this.$emit('incomingcall', { result, jsep });
    },
    accepted() {
      this.callDate = new Date();
      this.active = 'incall';
      if (/\*97/.test(this.callerid)) {
        if (this.callerid === "*97") {
          this.setIsListeningVoicemail(true);
        }
      }
      this.stop();
      this.$emit('accepted');
    },
    hangup(result) {
      if (result.code === 487 && this.callKey) {
        this.$notify({
          title: this.$t('call.lost-call'),
          message: this.$t('call.lost-call-message', { displayname: this.displayName, callerid : this.callerid }),
          duration: 0,
          position: "bottom-right",
        });
      }

      this.callKey = null;
      this.callerid = null;
      this.displayName = null;
      this.setIsListeningVoicemail(false);
      this.active = 'keypad';
      this.stop();
      this.$emit('hangup', result);
      this.currentCall.mute = false;
      this.currentCall.hold = false;
    },
    simpleHangup(){
      this.currentCall.mute = false;
      this.currentCall.hold = false;
      this.janus.hangup();
    },
    async calling() {
      this.active = 'calling'
      this.callerid = this.janus.getCallToNumber();
      this.displayName = this.janus.getCallToNumber() === '*97' ? 'Voicemail' : this.janus.getCallToNumber()
    },
    notify(message) {
      const methods = {
        ['message-summary'] : this.messageSummary,
      }

      const notify = message.notify

      if (notify in methods) {
        methods[notify](message)
      }
    },
    messageSummary(message) {
      const messages = parseInt(message.content.split('\r\n')[2].split(" ")[1].split("/").shift())
      this.setVoicemail(messages)
    },
    play() {
      this.$refs.audio.play()
    },
    stop() {
      this.$refs.audio.pause()
      this.$refs.audio.currentTime = 0
    },
    onJanusDestroy() {
      this.loadingJanus = false;
      if (this.active === 'incoming') {
        this.active = 'keypad'
      }
      if (this.janus) {
        this.janus.stopAllTracks();
        this.janus = null;
        this.connected = false;
      }
      if (this.isMainWindow) {
        this.initJanus();
      }
    },
    registered(){
      this.$emit('registered')
    },
    registrationFailed(){
      this.error.show = true;
      this.error.type = 'ExtensionRegisterError'
      this.$emit('registrationFailed')
    },
    sendDtmf(value) {
      this.janus?.sendDtmf(value)
    },
    assistedTransfer(value) {
      this.janus.sendDtmf(`*02${value}`)
      this.$emit('assisted-transfer', value)
    },
    goBackToCall() {
      this.janus.sendDtmf('**')
      this.active = 'incall'
      this.$emit('go-back-to-call')

    },
    bindTransfer(value) {
      this.janus.sendDtmf(`##${value}`)
      this.$emit('blind-transfer')
    },
    call(destination){
      this.janus.call(destination, destination).catch((error) => {
          if (error.name === "NotAllowedError" || error.name === "NoCaptureDevice") {
            this.error.show = true;
            this.error.type = error.name;
          } else if (error.name === "UnexpectedAnswer") {
            const sound = new Audio('/sounds/busy_phone_tone.mp3');
            sound.volume = 0.3;
            sound.play();
            setTimeout(() => {
              sound.pause();
            }, 2000);
          } else {
            this.$alert(error).catch(() => {})
          }
        });
        
      this.$emit('call', destination)
    },
    mute() {
      this.janus.mute();
      this.currentCall.mute = true;
    },
    unmute() {
      this.janus.unmute();
      this.currentCall.mute = false;
    },
    hold() {
      this.janus.hold();
      this.currentCall.hold = true;
    },
    unhold() {
      this.janus.unhold();
      this.currentCall.hold = false;
    },
    async answer(){
      try {
        await this.janus.answer(this.jsep)
      } catch (error) {
        if (error.name === "NotAllowedError" || error.name === "NoCaptureDevice") {
          this.error.show = true;
          this.error.type = error.name;
        } else if (error.name === "UnexpectedAnswer") {
          const sound = new Audio('/sounds/busy_phone_tone.mp3');
          sound.volume = 0.3;
          sound.play();
          setTimeout(() => {
            sound.pause();
          }, 2000);
        } else {
          this.$alert(error).catch(() => {})
        }
      }
    },
    checkIfExitstMediaDevices(kinds){
      return new Promise((resolve, reject) => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
          return reject(new Error('Media devices not supported'));
        }
        navigator.mediaDevices.enumerateDevices()
          .then((devices) => {
            const found = devices.filter(device => kinds.includes(device.kind));
            resolve(found);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkIfAllowedDevices(devices){
      return new Promise((resolve, reject) => {
        navigator.permissions.query(devices)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
  created() {
    if (this.isInCall) {
      this.active = 'incall'
    }
  },
  async mounted() {
    this.checkIfExitstMediaDevices(['audioinput']).then((devices) => {
      if (devices.length === 0) {
        this.error.show = true;
        this.error.type = 'NoCaptureDevice';
      }
    })


    this.checkIfAllowedDevices({name: 'microphone'}).then((result) => {
      if (result.state === 'denied') {
        this.error.show = true;
        this.error.type = 'NotAllowedError';
        console.log('denied');
        return;
      }else{
        if(result.state === 'prompt'){
          this.error.show = true;
          this.error.type = 'NotAllowedError';
          navigator.mediaDevices.getUserMedia({ audio: true })
          .then((stream) => {
            stream.getTracks().forEach(track => track.stop());
            this.error.show = false;
            this.error.type = null;
          })
        }
      }
    }).catch(() => {
      return;
    });
    
    this.janus = await this.initJanus();

    
    if (this.$refs.sipAudio) {
        this.$refs.sipAudio.volume = this.volume;
    }
    
    if (this.janus) {
        this.janus.attachAudio(this.$refs.sipAudio)
        this.janus.attachAudio(document.querySelector("#widget-audio"));
    }
    if (this.$refs.sipAudio && typeof this.$refs.sipAudio.sinkId !== "undefined") {
        this.$refs.sipAudio.setSinkId(this.outputDevice);
    }
  },
  watch : {
    volume(value) {
      this.$refs.sipAudio.volume = value
    },
    outputDevice(value) {
      if (typeof this.$refs.sipAudio.sinkId !== "undefined") {
        this.$refs.sipAudio.setSinkId(value)
        if (this.$refs.audio.setSinkId) {
          this.$refs.audio.setSinkId(value)
        }
      }
    },
    isInCall(value) {
      if (value) {
        this.active = 'incall'
      }
    },
    isMainWindow(value) {
      if (!value) {
        if (this.janus) {
          this.janus.destroy();
        }
      } else {
        this.initJanus();
      }
    },
    actions(values) {
      values
        .filter(value => value.type === 'call')
        .forEach(action => {
          let actionType = action.action
          if (this.janus) {
            if (action.action in this.janus) {
              if (this.active === 'incoming' && actionType === 'hangup') {
                actionType = 'decline';
              }
              if (actionType === "answer") {
                this.janus[actionType](this.jsep);
              } else {
                this.janus[actionType](action.data);
              }
            }
          }
        })
    },
    active(value){
      this.$emit('change-state', value)
    }
  }
}
</script>

<style scoped>
  .container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
  }

  .keypad {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: var(--column);
    grid-auto-rows: minmax(10px, auto);
  }

  .buttons {
    width: 100%;
    display: inline-flex;
    justify-content: space-around;
    margin-bottom: var(--column)
  }

  .center {
    margin: 0 auto;
  }

  .soft-phone {
    box-sizing: border-box;
    height: 100%;
  }
  .softphone-wraper{
    height: 100%;
    max-height: 470px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }
  .big {
    padding: 16px;
  }
</style>